import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Project } from '../../../models/project';
import { CachedProjectService } from '../../../shared/services/cached-project.service';
import { graphviz } from 'd3-graphviz'

@Component({
  selector: 'app-flowchart',
  templateUrl: './flowchart.component.html',
  styleUrls: ['./flowchart.component.css']
})
export class FlowchartComponent implements OnInit {
  project_id: string = '';
  project_name: string = '';
  is_getting_project_network: boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, private projectService: CachedProjectService) {
    this.projectService.currentProject.subscribe((project: Project) => {
      if (project != null) {
        this.project_id = project.id;
        this.project_name = project.name;
        console.log("started")
        this.get_project_network(this.project_id)
      } 
    });
  }

  get_project_network(project_id, FM=false) {
    this.is_getting_project_network = true;
    console.log("getting network")
    this.projectService.getProjectNetwork(project_id, FM).toPromise().then(data => {
      console.log("received data")
      console.log(data)
      
    graphviz("#graph")
    .renderDot(data['graphviz']);
    });
  }
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/projects/project-view/flowchart/flowchart.component.ts